import React from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Header, CBContainer } from './styled';
import Checkbox from '../checkbox';
import { DISABLED } from '../checkbox/constants';
import getSelectableCheckboxState from '../checkbox/get-selectable-checkbox-state';
import InstructionHubFeedback from '../instruction-hub-feedback';
import { INSTRUCTION_HUB_MESSAGE_CONTEXTS } from '../instruction-hub-message';
import { GRID_CELL_SELECTION } from '../../containers/course-assign/course-assign-types';
import { countInstructionHubBlockedAssignments } from '../../helpers/instruction-hub/instruction-hub-assignments';

const HeaderCheckbox = ({ indexes, i18n }) => {
  const dispatch = useDispatch();
  const studentAssignments = useSelector(
    (state) =>
      indexes.map(
        (x) => state.CourseAssignReducer.assignments.studentAssignments[x]
      ),
    shallowEqual
  );
  const instructionHubBlockedLookup = useSelector(
    (state) => state.CourseAssignReducer.instructionHubBlockedLookup
  );
  const checkboxState = getSelectableCheckboxState({
    selectedCount: studentAssignments.filter(({ isSelected }) => isSelected)
      .length,
    totalCount: studentAssignments.length,
    blockedCount: countInstructionHubBlockedAssignments(
      studentAssignments,
      instructionHubBlockedLookup
    )
  });

  function handleOnClick(cbStatus) {
    dispatch({
      type: GRID_CELL_SELECTION,
      indexes,
      status: cbStatus
    });
  }

  return (
    <CBContainer>
      <InstructionHubFeedback
        i18n={i18n}
        context={INSTRUCTION_HUB_MESSAGE_CONTEXTS.ACTIVITY}
        isBlocked={checkboxState === DISABLED}
      >
        <Checkbox
          checkboxHandler={(cbStatus) => handleOnClick(cbStatus)}
          state={checkboxState}
        />
      </InstructionHubFeedback>
    </CBContainer>
  );
};

HeaderCheckbox.propTypes = {
  indexes: PropTypes.arrayOf(PropTypes.number).isRequired,
  i18n: PropTypes.object.isRequired
};

const GridHeader = (props) => {
  const { activities, mappedAssignmentIndexes, i18n } = props;

  return (
    <Header>
      {activities.map((activity) => (
        <HeaderCheckbox
          key={`${activity.activityId}_${activity.activityName}`}
          indexes={mappedAssignmentIndexes?.[activity.activityName] || []}
          i18n={i18n}
        />
      ))}
    </Header>
  );
};

GridHeader.propTypes = {
  i18n: PropTypes.object.isRequired,
  activities: PropTypes.array.isRequired,
  mappedAssignmentIndexes: PropTypes.object.isRequired
};

GridHeader.defaultProps = {
  activityIds: []
};

export default GridHeader;



// WEBPACK FOOTER //
// ./components/grid/grid-header.js